import { Button } from "antd"
import styled from "styled-components"

import Flex from "#blocks/Flex"
import { useUserContext } from "#contexts/UserContextProvider"
import { camelToWords } from "#utils/textFormatters"

const SBanner = styled.div`
  width: 100vw;
  padding: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  background-color: #ff4d4f;
  color: white;
  font-weight: 600;
  font-size: 14px;
`

const ImpersonationBanner = () => {
  const { impersonatedUserId, effectiveUser, stopImpersonation } =
    useUserContext()

  if (!impersonatedUserId || !effectiveUser) return null

  const roleName = effectiveUser.role ? camelToWords(effectiveUser.role) : ""

  return (
    <SBanner>
      <Flex center gap={8}>
        <span>⚠️ Viewing as: {effectiveUser.name}</span>
        {roleName && <span>({roleName})</span>}
      </Flex>
      <Button size="small" onClick={stopImpersonation} type="default">
        Stop Impersonation
      </Button>
    </SBanner>
  )
}

export default ImpersonationBanner
